import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import cx from "classnames";
import { Row, Col, Label } from "reactstrap";
import { AppCard, PageLayout } from "../../components/ui";
import { AddKycDocument, DocumentFile, KycSubmission, KycSubmissionComment, modifyStatus } from "../../models/KycSubmission";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Check, X, Info, AlertTriangle, Save, User as UserIcon, Pencil, Search } from "lucide-react";
import { kycSubmissionApiService } from "../../services/api/Kyc/KycSubmissionApiService";
import { utils, countryCodeToFlag } from "../../utils/utils";
import { toastService } from "../../services/toastService";
import { fileService } from "../../services/FileService";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { User, UserAddress, UserProfileUpdate } from "../../models/User";
import AddManualKyc from "../Users/AddManualKyc";
import { isKYCAssessAllowed, isKYCApproveAllowed, isKycSubmissionAllAllowed, isCRMAllAllowed, isSuperAdmin, isIndividualDocumentsViewAllowed } from "../../authGuard";
import { featureFlagApiService } from "../../services/api/featureFlags/FeatureFlagApiService";
import UserDocumentsComponent from "../Users/UserDocumentsComponent";
import { SelectItem } from "../../models/SelectItem";
import { userApiService } from "../../services/api/users/UsersApiService";
import { httpService } from "../../services/HttpService";
import AddUserAddress from "../Users/UserAddressUpdate";
import ResidencePermitSection from "../Users/ResidencePermitSection";
import { RESIDENCE_PERMIT_STATUS_SAVE_FAILED_TOAST, ResidencePermitLoadState, isResidencePermitApprovalBlocked, residencePermitApprovalBlockedMessage, residencePermitFailureMessage } from "../Users/residencePermitRules";
import ExtendedDropdown from "../../components/ExtendedDropdown";
import KycSubmissionCommentForm from "./KycComments";
import { Tag } from "primereact/tag";
import { TabMenu } from "primereact/tabmenu";
import _ from "lodash";
import { riskApiService } from "../../services/RiskService";
import { DowJonesSearch } from "../../models/Risk";
import { ComplianceSearchRequest, ComplianceSearchResponse, SearchListEnum } from "../../models/Compliance";
import { FlattenedEntry } from "../../models/FlattenedEntry";
import { WatchListEntryEsModel } from "../../models/RabbitSolutions";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { ResidencePermit, ResidencePermitResponse } from "../../models/ResidencePermit";
import { CustomerPepDeclaration } from "./components/CustomerPepDeclaration";
import { FLAG_HIGHLIGHT_BACKGROUND, FLAG_HIGHLIGHT_BORDER_COLOR, flagCheckboxStyle, flagLabelStyle, flagSectionStyle } from "./components/flagSectionStyles";
import { ComplianceReviewRequest, KycSubmissionDocument } from "../../models/KycSubmission";
import ReactJson from "react-json-view";
const MIN_COUNTRY_OVERRIDE_REASON_LENGTH = 5;
const MAX_COUNTRY_OVERRIDE_REASON_LENGTH = 1024;
const MERCHANT_PORTAL_DOCUMENTS_FLAG = "merchantportal.additional_documents";
// KycStatus.UnderReview (Alaric.Domains.CommonDb/Model/KycStatus.cs) — the FE has no shared status
// enum (queue pages fetch labels from getKycStatusTypes() instead), so this one raw value is kept
// local rather than introducing a new enum for a single comparison.
const KYC_STATUS_UNDER_REVIEW = 3;
const NEW_DOCUMENT_UPLOADED_REASON = "New customer document uploaded";

interface KycIndividualProps {
    submission: KycSubmission;
    onHide: () => void;
}

interface KycIndividualState {
    showRejectDialog: boolean;
    submission: KycSubmission;
    rejectionReason: string;
    isLoading: boolean;
    kycDocuments: DocumentFile[];
    kycComments: KycSubmissionComment[];
    individual: User | null;
    isReadOnly: boolean;
    isAddressDetailVisible: boolean;
    isDowJonesComplianceDetailsVisible: boolean;
    dowJonesComplianceResult: ComplianceSearchResponse | null;
    selectedAddress: UserAddress | null;
    disableSubmitBtn: boolean;
    disableApproveBtn: boolean;
    minimumMatchingPercentageSIP: number | null;
    minimumMatchingPercentagePEP: number | null;
    ninChecked: boolean;
    pinChecked: boolean;
    dlgNinChecked: boolean;
    dlgPinChecked: boolean;
    isSavingReview: boolean;
    showComplianceDialog: boolean;
    complianceDocuments: KycSubmissionDocument[];
    complianceDocsLoading: boolean;
    documentsFeatureEnabled: boolean;
    ninInput: string;
    pinInput: string;
    docUrls: Record<string, string>;
    lightboxUrl: string | null;
    ninError: string;
    pinError: string;
    mrzLine1: string;
    mrzLine2: string;
    mrzLine3: string;
    mrzCalculating: boolean;
    mrzResult: string | null;
    countryOverrideReason: string;
    countryOverrideReasonError: string;
    isEditingCountryOverride: boolean;
    showDiscardCountryOverrideDialog: boolean;
    editEnrollCountryCode: string;
    editIpCountryCode: string;
    editGeoLocationCountryCode: string;
    // Only what the Approve lock and the save-draft EU/EEA marking need; the section itself owns the rest.
    residencePermit: ResidencePermit | null;
    isMemberOfEuEea: boolean;
    // Picks the Approve tooltip while the permit locks it: loading, GET failed, or permit missing.
    residencePermitLoadState: ResidencePermitLoadState;
}

export default class KycIndividualModal extends Component<KycIndividualProps, KycIndividualState> {
    validationErrors: Map<string, boolean> = new Map<string, boolean>();
    countryNames: Map<string, string> = new Map<string, string>();
    originalEnrollCountryCode = "";
    originalIpCountryCode = "";
    originalGeoLocationCountryCode = "";

    constructor(props: KycIndividualProps | Readonly<KycIndividualProps>) {
        super(props);

        this.state = {
            showRejectDialog: false,
            rejectionReason: "",
            isLoading: true,
            submission: this.props.submission,
            kycDocuments: [],
            kycComments: [],
            individual: null,
            isReadOnly: false,
            isAddressDetailVisible: false,
            isDowJonesComplianceDetailsVisible: false,
            dowJonesComplianceResult: null,
            selectedAddress: null,
            disableSubmitBtn: false,
            disableApproveBtn: false,
            minimumMatchingPercentageSIP: null,
            minimumMatchingPercentagePEP: null,
            ninChecked: props.submission.ninReviewNotRequiredOrSolved,
            pinChecked: props.submission.pinReviewNotRequiredOrSolved,
            dlgNinChecked: props.submission.ninReviewNotRequiredOrSolved,
            dlgPinChecked: props.submission.pinReviewNotRequiredOrSolved,
            isSavingReview: false,
            showComplianceDialog: false,
            documentsFeatureEnabled: false,
            complianceDocuments: [],
            complianceDocsLoading: false,
            ninInput: props.submission.nationalIdNumber ?? "",
            pinInput: props.submission.personalIdentificationNumber ?? "",
            docUrls: {},
            lightboxUrl: null,
            ninError: "",
            pinError: "",
            mrzLine1: "",
            mrzLine2: "",
            mrzLine3: "",
            mrzCalculating: false,
            mrzResult: null,
            countryOverrideReason: "",
            countryOverrideReasonError: "",
            isEditingCountryOverride: false,
            showDiscardCountryOverrideDialog: false,
            editEnrollCountryCode: "",
            editIpCountryCode: "",
            editGeoLocationCountryCode: "",
            residencePermit: null,
            isMemberOfEuEea: false,
            residencePermitLoadState: "loading",
        };
    }

    // Permission-only, deliberately not isComplianceOfficer()/isComplianceOfficerApprover(): those
    // match a plain role-name string, and a tenant-created role has its "|{tenantId}" suffix
    // stripped on the claim the same way CRM's GetRoleName() does — so a merchant naming its own
    // role "Compliance Officer" would pass with zero KYC permission. ComplianceOfficerPermissionBundle
    // /ComplianceOfficerApproverPermissionBundle both carry KycSubmissionAll, already covered below.
    // isSuperAdmin() is the one deliberate exception, mirroring CanEditCountryOverridesAsync's own
    // IsSuperAdmin() short-circuit on the backend — that role has zero DB permissions and is let
    // through by the shared PermissionAuthorize pipeline on role name alone.
    canEditCountryOverrides = (): boolean => isKYCApproveAllowed() || isKycSubmissionAllAllowed() || isCRMAllAllowed() || isSuperAdmin();

    // Compares the editor's own draft state against the baseline captured when the editor was
    // opened (see onToggleEditCountryOverride) — never against individual.enrollCountryCode etc.
    // directly, since those are the Risk Engine's last-evaluation output, not what's being edited.
    countryCodesChanged = (): boolean =>
        this.state.editEnrollCountryCode !== this.originalEnrollCountryCode
            || this.state.editIpCountryCode !== this.originalIpCountryCode
            || this.state.editGeoLocationCountryCode !== this.originalGeoLocationCountryCode;

    // Runs whenever the compliance officer finishes editing the country overrides
    // (via "Done" or a Save/Approve/Submit/Reject/Escalate click) so a code change
    // can never slip through without a reason, regardless of which action they used.
    validateCountryOverride = (): boolean => {
        if (!this.canEditCountryOverrides() || !this.countryCodesChanged()) {
            return true;
        }

        if (!this.state.editEnrollCountryCode || !this.state.editIpCountryCode || !this.state.editGeoLocationCountryCode) {
            toastService.error("Country of Registration, IP country and Geolocation are all required when overriding country parameters.");
            return false;
        }

        const reason = this.state.countryOverrideReason.trim();
        if (reason.length < MIN_COUNTRY_OVERRIDE_REASON_LENGTH) {
            this.setState({ countryOverrideReasonError: `Reason must be at least ${MIN_COUNTRY_OVERRIDE_REASON_LENGTH} characters long.` });
            toastService.error("Please provide a reason for the country parameter override.");
            return false;
        }

        return true;
    };

    onToggleEditCountryOverride = () => {
        if (this.state.isEditingCountryOverride && !this.validateCountryOverride()) {
            return;
        }

        if (!this.state.isEditingCountryOverride && !this.hasUnsavedCountryOverrideEdits()) {
            // Individual.enrollCountryCode/ipCountryCode/geoLocationCountryCode are the Risk
            // Engine's last-evaluation output, not the compliance-supplied input — they only match
            // the current override once a post-save re-score has echoed it back, and the read-only
            // scorecard must always show that value, never a pending edit. So the editor gets its
            // own draft state (editEnrollCountryCode etc.), seeded from the current override when
            // one exists (else falling back to the Individual's own fields for a first-ever
            // override) and never written onto state.individual until a successful save. Guarded on
            // hasUnsavedCountryOverrideEdits(): without it, reopening the dialog after "Done"
            // (closed but not yet saved) would re-seed from the still-old currentRiskCountryOverride
            // and silently wipe the officer's pending edit — countryCodesChanged() would then read
            // false and the next save would send no override at all.
            const individual = this.state.individual as User;
            const override = individual.currentRiskCountryOverride;
            const seedEnroll = override?.enrollCountryCodeOverride ?? individual.enrollCountryCode ?? "";
            const seedIp = override?.ipCountryCodeOverride ?? individual.ipCountryCode ?? "";
            const seedGeo = override?.geoLocationCountryCodeOverride ?? individual.geoLocationCountryCode ?? "";
            this.originalEnrollCountryCode = seedEnroll;
            this.originalIpCountryCode = seedIp;
            this.originalGeoLocationCountryCode = seedGeo;
            this.setState({
                editEnrollCountryCode: seedEnroll,
                editIpCountryCode: seedIp,
                editGeoLocationCountryCode: seedGeo,
            });
        }

        this.setState({ isEditingCountryOverride: !this.state.isEditingCountryOverride });
    };

    hasUnsavedCountryOverrideEdits = (): boolean => this.countryCodesChanged() || this.state.countryOverrideReason.trim().length > 0;

    onCancelEditCountryOverride = () => {
        if (this.hasUnsavedCountryOverrideEdits()) {
            this.setState({ showDiscardCountryOverrideDialog: true });
            return;
        }
        this.setState({ isEditingCountryOverride: false });
    };

    onConfirmDiscardCountryOverride = () => {
        this.setState({
            editEnrollCountryCode: this.originalEnrollCountryCode,
            editIpCountryCode: this.originalIpCountryCode,
            editGeoLocationCountryCode: this.originalGeoLocationCountryCode,
            countryOverrideReason: "",
            countryOverrideReasonError: "",
            isEditingCountryOverride: false,
            showDiscardCountryOverrideDialog: false,
        });
    };

    // PrimeReact passes the dropdown's props as the second argument. With nothing selected the
    // placeholder is shown, so the field keeps its height (an empty span collapsed it).
    selectedCountryOverrideTemplate = (option: SelectItem, props?: { placeholder?: string }): React.ReactNode => {
        if (option) {
            return (
                <div className="flex items-center gap-2">
                    <span className="text-base leading-none">{countryCodeToFlag(option.value)}</span>
                    <span>{option.label}</span>
                </div>
            );
        }
        return <span>{props?.placeholder || "\u00a0"}</span>;
    };

    countryOverrideOptionTemplate = (option: SelectItem): React.ReactNode => (
        <div className="flex items-center gap-2">
            <span className="text-base leading-none">{countryCodeToFlag(option.value)}</span>
            <span>{option.label}</span>
        </div>
    );

    onCountryOverrideReasonChange = (value: string) => {
        this.setState({
            countryOverrideReason: value,
            countryOverrideReasonError: value.length > 0 && value.length < MIN_COUNTRY_OVERRIDE_REASON_LENGTH
                ? `Reason must be at least ${MIN_COUNTRY_OVERRIDE_REASON_LENGTH} characters long.`
                : "",
        });
    };

    // The Residence Permit section owns its GET; this keeps the modal's two dependants — the Approve
    // lock (residencePermitApprovalBlocked) and the EU/EEA save-draft marking — in step with it.
    // null means the GET failed: the Approve lock then treats the client as non-EU/EEA with no permit
    // (fail closed), its tooltip says the data could not be loaded, and the section offers a Retry.
    onResidencePermitLoaded = (response: ResidencePermitResponse | null) => {
        this.setState({
            residencePermit: response?.residencePermitData?.[0] ?? null,
            isMemberOfEuEea: response?.isMemberOfEuEea === true,
            residencePermitLoadState: response ? "loaded" : "failed",
        });
    };

    // Called from onSaveDraft, so also before Submit, Approve, Reject and Escalate. For an EU/EEA
    // national (the section is hidden) PUT /Individual/{submissionId}/kyc-residence-permit marks the
    // residence-permit requirement as not applicable on the submission; for anyone else the POST on
    // "Done" already keeps the submission in step. A failure stops the save, so Approve or Submit do
    // not go ahead.
    markResidencePermitNotRequiredIfEuEea = async (): Promise<boolean> => {
        if (!this.state.isMemberOfEuEea) {
            return true;
        }

        const result = await userApiService.markResidencePermitNotRequired(this.props.submission.id);
        if (!result.success) {
            toastService.error(residencePermitFailureMessage(result, RESIDENCE_PERMIT_STATUS_SAVE_FAILED_TOAST));
            return false;
        }
        return true;
    };

    sourceOfFunds: SelectItem[] = [];
    countries: SelectItem[] = [];
    financingMethods: SelectItem[] = [];
    accountPurposes: SelectItem[] = [];
    mainActivities: SelectItem[] = [];

    componentDidMount = async () => {
        this.setState({ isLoading: true });

        featureFlagApiService.isEnabled(MERCHANT_PORTAL_DOCUMENTS_FLAG).then((enabled) => {
            this.setState({ documentsFeatureEnabled: enabled });
        });

        const individualResult = await userApiService.getFromSubmission(this.props.submission.id);
        if (!individualResult.success) {
            toastService.error(individualResult.message);
            return;
        }

        // Seed both the dirty-check baseline and the editor's own draft state to the same fetched
        // values so countryCodesChanged() is false by default — validateCountryOverride() runs on
        // every save regardless of whether the country-override editor was ever opened, and it
        // would otherwise compare an untouched "" draft against a non-empty fetched baseline and
        // spuriously demand all three fields plus a reason on an unrelated save.
        this.originalEnrollCountryCode = individualResult.data.enrollCountryCode ?? "";
        this.originalIpCountryCode = individualResult.data.ipCountryCode ?? "";
        this.originalGeoLocationCountryCode = individualResult.data.geoLocationCountryCode ?? "";
        this.setState({
            individual: individualResult.data,
            editEnrollCountryCode: this.originalEnrollCountryCode,
            editIpCountryCode: this.originalIpCountryCode,
            editGeoLocationCountryCode: this.originalGeoLocationCountryCode,
            // componentDidMount also runs after a successful save that touched something other
            // than the country override (see onSaveDraft) — reset alongside the baselines above so
            // a stale reason from an earlier abandoned edit can't linger past this reload either.
            countryOverrideReason: "",
            countryOverrideReasonError: "",
        });

        const countriesResult = await utils.getCountriesResult();
        if (!countriesResult.success) {
            toastService.error(countriesResult.message);
            this.setState({ isLoading: false });
            return;
        }

        this.countries = utils.getCountries();

        const sourceOfFunds = await userApiService.getSourceOfFunds();
        if (!sourceOfFunds.success) {
            toastService.error(sourceOfFunds.message);
            this.setState({ isLoading: false });
            return;
        }
        this.sourceOfFunds = sourceOfFunds.data;

        const financingMethods = await userApiService.getFinancingMethod();
        if (!financingMethods.success) {
            toastService.error(financingMethods.message);
            this.setState({ isLoading: false });
            return;
        }
        this.financingMethods = financingMethods.data;

        const accountPurposes = await userApiService.getAccountPurpose();
        if (!accountPurposes.success) {
            toastService.error(accountPurposes.message);
            this.setState({ isLoading: false });
            return;
        }
        this.accountPurposes = accountPurposes.data;

        const mainActivities = await userApiService.getMainActivity();
        if (!mainActivities.success) {
            toastService.error(mainActivities.message);
            this.setState({ isLoading: false });
            return;
        }
        this.mainActivities = mainActivities.data;

        this.setState({ isLoading: false });
    };

    get complianceReviewRequired(): boolean {
        return !this.state.ninChecked || !this.state.pinChecked;
    }

    // Same rule as the section's banner (isResidencePermitApprovalBlocked).
    get residencePermitApprovalBlocked(): boolean {
        return isResidencePermitApprovalBlocked(this.state.isMemberOfEuEea, this.state.residencePermit);
    }

    extractMrzFromMetadata = (): { line1: string; line2: string; line3: string } => {
        try {
            const parsed = JSON.parse(this.props.submission.externalIdentificationMetadata ?? "");
            const tasks: any[] = parsed?.tasks ?? [];
            const task = tasks.find((t: any) => t.task_def_id === "document_check_with_address_information");
            const props = task?.output?.properties ?? {};
            return {
                line1: props.mrz_line1 ?? "",
                line2: props.mrz_line2 ?? "",
                line3: props.mrz_line3 ?? "",
            };
        } catch {
            return { line1: "", line2: "", line3: "" };
        }
    };

    openComplianceDialog = async () => {
        const mrz = this.extractMrzFromMetadata();
        this.setState({
            showComplianceDialog: true,
            complianceDocsLoading: true,
            docUrls: {},
            mrzLine1: mrz.line1,
            mrzLine2: mrz.line2,
            mrzLine3: mrz.line3,
            mrzResult: null,
            dlgNinChecked: this.state.ninChecked,
            dlgPinChecked: this.state.pinChecked,
            ninInput: this.state.individual?.nationalIdNumber ?? "",
            pinInput: this.state.individual?.personalIdentificationNumber ?? "",
            ninError: "",
            pinError: "",
        });
        const result = await kycSubmissionApiService.getDocuments(this.props.submission.id);
        if (!result.success) {
            this.setState({ complianceDocsLoading: false });
            return;
        }
        const docs: KycSubmissionDocument[] = result.data;
        const urls: Record<string, string> = {};
        await Promise.all(
            docs.map(async (doc) => {
                const fileResult = await fileService.GetFile(doc.fileStorageId);
                if (fileResult.success) {
                    urls[doc.fileStorageId] = utils.appendBase64Data(fileResult.data, doc.fileName);
                }
            })
        );
        this.setState({ complianceDocuments: docs, docUrls: urls, complianceDocsLoading: false });
    };

    validateComplianceFields = (): boolean => {
        // NIN: backend rule — ^[A-Za-z0-9]{2,20}$
        const ninRegex = /^[A-Za-z0-9]{2,20}$/;
        // PIN: backend rule — ^[a-zA-Z0-9]*$  +  length 9-20  +  not all-zeros  +  not all-spaces
        const pinRegex = /^[a-zA-Z0-9]*$/;

        const nin = this.state.ninInput;
        const pin = this.state.pinInput;
        let ninError = "";
        let pinError = "";

        if (!nin) {
            ninError = "National ID Number is required.";
        } else if (!ninRegex.test(nin)) {
            if (nin.length < 2 || nin.length > 20) {
                ninError = "National ID Number must be between 2 and 20 characters.";
            } else {
                ninError = "National ID Number must contain only letters and digits (no spaces or special characters).";
            }
        }

        if (!pin) {
            pinError = "Personal Identification Number is required.";
        } else if (pin.length < 9 || pin.length > 20) {
            pinError = "Personal Identification Number must be between 9 and 20 characters.";
        } else if (!pinRegex.test(pin)) {
            pinError = "Personal Identification Number must contain only letters and digits (no spaces or special characters).";
        } else if (/^0+$/.test(pin)) {
            pinError = "Personal Identification Number cannot consist entirely of zeros.";
        } else if (/^ +$/.test(pin)) {
            pinError = "Personal Identification Number cannot consist entirely of spaces.";
        }

        if (!ninError && !this.state.dlgNinChecked) {
            ninError = "Please confirm National ID Number has been reviewed.";
        }
        if (!pinError && !this.state.dlgPinChecked) {
            pinError = "Please confirm Personal Identification Number has been reviewed.";
        }

        this.setState({ ninError, pinError });
        return !ninError && !pinError;
    };

    calculateMrz = async () => {
        this.setState({ mrzCalculating: true, mrzResult: null });
        try {
            const result = await httpService.post<string>("/Enrollment/mrz/parse", {
                mrzLine1: this.state.mrzLine1 || null,
                mrzLine2: this.state.mrzLine2 || null,
                mrzLine3: this.state.mrzLine3 || null,
            });
            this.setState({ mrzResult: result.success ? (result.data ?? "") : "" });
        } catch {
            this.setState({ mrzResult: "" });
        } finally {
            this.setState({ mrzCalculating: false });
        }
    };

    onSaveComplianceReview = async () => {
        if (!this.validateComplianceFields()) return;
        this.setState({ isSavingReview: true });
        const request: ComplianceReviewRequest = {
            nationalIdNumber: this.state.ninInput || null,
            personalIdentificationNumber: this.state.pinInput || null,
            ninReviewNotRequiredOrSolved: this.state.dlgNinChecked,
            pinReviewNotRequiredOrSolved: this.state.dlgPinChecked,
        };
        const result = await kycSubmissionApiService.updateComplianceReview(this.props.submission.id, request);
        this.setState({ isSavingReview: false });
        if (!result.success) {
            toastService.error(result.message);
            return;
        }
        toastService.success("Compliance review saved.");
        this.setState({
            showComplianceDialog: false,
            ninChecked: this.state.dlgNinChecked,
            pinChecked: this.state.dlgPinChecked,
        });
        this.onFieldUpdate("nationalIdNumber", this.state.ninInput);
        this.onFieldUpdate("personalIdentificationNumber", this.state.pinInput);
    };

    onSubmit = async () => {
        this.setState({ disableSubmitBtn: true });

        const saveResult = await this.onSaveDraft();
        if (saveResult) {
            const result = await kycSubmissionApiService.kycSubmit(this.props.submission!.id);

            if (!result.success) {
                this.setState({ disableSubmitBtn: false });
                toastService.error(result.message);
            } else {
                this.setState({ disableSubmitBtn: false });
                this.props.onHide();
            }
        }
        this.setState({ disableSubmitBtn: false });
    };

    onApprove = async () => {
        this.setState({ disableApproveBtn: true });

        const saveResult = await this.onSaveDraft();
        if (saveResult) {
            const result = await kycSubmissionApiService.transitionToApproved(this.props.submission!.id);

            if (!result.success) {
                toastService.error(result.message);
                this.setState({ disableApproveBtn: false });
            } else {
                this.setState({ disableApproveBtn: false });
                this.props.onHide();
            }
        }
        this.setState({ disableApproveBtn: false });
    };

    onReject = async () => {
        const saveResult = await this.onSaveDraft();
        if (saveResult) {
            this.setState({ showRejectDialog: true });
        }
    };

    onEscalate = async () => {
        const saveResult = await this.onSaveDraft();
        if (saveResult) {
            const result = await kycSubmissionApiService.kycEscalate(this.props.submission!.id);

            if (!result.success) {
                toastService.error(result.message);
            } else this.props.onHide();
        }
    };

    onSaveDraft = async () => {
        if (!this.validateCountryOverride()) {
            return false;
        }

        const overrideReason = this.state.countryOverrideReason.trim();
        const hasCountryOverride = this.canEditCountryOverrides() && this.countryCodesChanged();

        this.setState({ isLoading: true });

        if (!(await this.markResidencePermitNotRequiredIfEuEea())) {
            this.setState({ isLoading: false });
            return false;
        }

        //Save user
        const newData = this.state.individual as User;
        const objToPost: UserProfileUpdate = {
            id: newData.id,
            firstName: newData.firstName,
            middleName: newData.middleName ?? "",
            lastName: newData.lastName,
            nonLatinFirstName: newData.nonLatinFirstName,
            nonLatinMiddleName: newData.nonLatinMiddleName ?? "",
            nonLatinLastName: newData.nonLatinLastName,
            email: newData.email,
            photo: newData.photo,
            birthDate: newData.birthDate,
            phoneNumber: newData.phoneNumber,
            cryptoCustomer: newData.cryptoCustomer,
            sourceOfFundId: newData.sourceOfFundId,
            residenceAddress: newData.residenceAddress,
            correspondenceAddress: newData.correspondenceAddress,
            nationalities: newData.nationalities,
            taxResidences: newData.taxResidences,
            nationalIdNumber: newData.nationalIdNumber,
            primaryLanguage: newData.primaryLanguage,
            secondaryLanguage: newData.secondaryLanguage,
            merchantGroupId: newData.merchantGroupId,
            accountPurposeCode: newData.accountPurposeCode,
            mainActivityCode: newData.mainActivityCode,
            financingMethodCode: newData.financingMethodCode,
            personalIdentificationNumber: newData.personalIdentificationNumber,
            isPEP: newData.isPEP,
            isSIP: newData.isSIP,
            gender: newData.gender,
            minimumMatchingPercentageSIP: this.state.minimumMatchingPercentageSIP ?? 0,
            minimumMatchingPercentagePEP: this.state.minimumMatchingPercentagePEP ?? 0,
        } as UserProfileUpdate;

        if (hasCountryOverride) {
            objToPost.enrollCountryCodeOverride = this.state.editEnrollCountryCode;
            objToPost.ipCountryCodeOverride = this.state.editIpCountryCode;
            objToPost.geoLocationCountryCodeOverride = this.state.editGeoLocationCountryCode;
            objToPost.riskCountryOverrideReason = overrideReason;
        }

        const result = await userApiService.updateForCompliance(objToPost);
        if (!result.success) {
            toastService.error(result.message);
        } else {
            // Clear on every successful save, not just hasCountryOverride ones — a reason typed
            // without a code change (hasCountryOverride false) would otherwise linger forever and
            // keep hasUnsavedCountryOverrideEdits() true, permanently blocking the editor from
            // re-seeding from currentRiskCountryOverride on the next open.
            this.setState({ countryOverrideReason: "", countryOverrideReasonError: "", isEditingCountryOverride: false });
        }

        //Save Comments kycComments
        let kycCommentsResult;
        this.state.kycComments.forEach(async (comment) => {
            if (comment.modifyStatus == modifyStatus.New) {
                comment.id = null;
                kycCommentsResult = await kycSubmissionApiService.putkycComment(comment);
                if (!result.success) {
                    toastService.error(kycCommentsResult.message);
                    return;
                }
            }
        });

        //Save Documents
        const allDocuments = this.state.kycDocuments;

        if (allDocuments.length > 0) {
            this.setState({ isLoading: true });

            for (const file of allDocuments) {
                if (file.isUploaded === true || file.fileStorageId !== "") {
                    continue;
                }
                const fileObjToPost: AddKycDocument = {
                    submissionId: this.props.submission.id,
                    fileName: file.file?.name,
                    fileData: (await utils.convertFileToBase64(file.file!)) as string,
                    type: file.documentType,
                } as AddKycDocument;

                const document = await kycSubmissionApiService.putkycDocument(fileObjToPost);

                if (!document.success) {
                    this.setState({ isLoading: false });

                    toastService.error(document.message);
                    return;
                }
                file.isUploaded = true;

                this.setState({ kycDocuments: allDocuments });
            }
            this.setState({ isLoading: false });
        }

        this.setState({ isLoading: false });

        // Only reload on success — nothing changed server-side on failure, and refetching would
        // silently wipe the officer's unsaved edits (including a pending country override) along
        // with the "original" tracking values used to detect it on the next save attempt.
        if (result.success) {
            this.componentDidMount();
        }
        return result.success;
    };

    onRejectWithReason = async () => {
        const result = await kycSubmissionApiService.transitionToRejected(this.props.submission!.id, this.state.rejectionReason);

        if (!result.success) {
            toastService.error(result.message);
        } else {
            this.props.onHide();
        }
        this.setState({ showRejectDialog: false });
    };

    addorEditAddress = (type: string, address: UserAddress) => {
        const objAddress = _.cloneDeep(address);
        objAddress.type = type;
        this.setState({ isAddressDetailVisible: true, selectedAddress: objAddress });
    };

    private transformMinMatchingPercantageValue = (val: number | null) => {
        if (val === null) return 0; // empty -> send 0
        if (val === 0) return 1; // 0 -> send 1
        return val;
    };

    showDowJonesComplianceDetail = async () => {
        try {
            const complianceSearchRequest: ComplianceSearchRequest = {
                clientId: this.state.individual?.id?.toString() ?? "",
                firstName: `${this.state.individual?.firstName ?? ""}`,
                middleName: `${this.state.individual?.middleName ?? ""}`,
                lastName: `${this.state.individual?.lastName ?? ""}`,
                fullName: utils.buildFullName(this.state.individual?.firstName, this.state.individual?.middleName, this.state.individual?.lastName),
                searchLists: [SearchListEnum.PEP, SearchListEnum.NIL],
                minimumMatchingPercentageNIL: this.transformMinMatchingPercantageValue(this.state.minimumMatchingPercentageSIP),
                minimumMatchingPercentagePEP: this.transformMinMatchingPercantageValue(this.state.minimumMatchingPercentagePEP),
            };

            const complianceResult = await riskApiService.dowJonesComplianceFuzzySearchByName(complianceSearchRequest);

            if (!complianceResult.success) {
                toastService.error(complianceResult.message);
                return;
            }

            this.setState({ isDowJonesComplianceDetailsVisible: true, dowJonesComplianceResult: complianceResult.data });
        } catch (ex) {
            let errorMessage = "An unknown error occurred.";

            if (ex instanceof Error) {
                errorMessage = ex.message;
            } else if (typeof ex === "string") {
                errorMessage = ex;
            }

            toastService.error(errorMessage);
            return;
        }
    };

    renderDowJonesComplianceResult = () => {
        // Check if the state and data exist
        if (!this.state.dowJonesComplianceResult) {
            return (
                <div>
                    <label>No data found</label>
                </div>
            );
        }

        const { minimumMatchingPercentageNIL, minimumMatchingPercentagePEP, consumedTimeInMs, clientId, watchListEntries } =
            this.state.dowJonesComplianceResult;

        return (
            <div>
                {/* Always show metadata */}
                <div>
                    <p>
                        <strong>Client ID:</strong> {clientId ?? "N/A"}
                    </p>
                    <p>
                        <strong>Minimum matching percentage (SIP):</strong> {minimumMatchingPercentageNIL ?? "N/A"}
                    </p>
                    <p>
                        <strong>Minimum matching percentage (PEP):</strong> {minimumMatchingPercentagePEP ?? "N/A"}
                    </p>
                    <p>
                        <strong>Consumed Time (ms):</strong> {consumedTimeInMs ?? "N/A"}
                    </p>
                </div>
                <hr />
                {/* Conditionally render table or fallback message */}
                {watchListEntries && watchListEntries.length > 0 ? (
                    <>
                        <p>
                            <strong>WatchList entries:</strong>
                        </p>
                        {this.renderTable(watchListEntries)}
                    </>
                ) : (
                    <p style={{ fontSize: "1.2em", fontWeight: "bold", color: "#555" }}>No watchlist entries found</p>
                )}
            </div>
        );
    };

    flattenObject = (obj: any, parentKey: string = ""): FlattenedEntry[] => {
        if (obj === null || obj === undefined) return [];
        const result: FlattenedEntry[] = [];

        if (typeof obj !== "object") {
            result.push({ key: parentKey, value: utils.formatAsYYYYMMDDIfIso(String(obj)) });
            return result;
        }

        if (Array.isArray(obj)) {
            obj.forEach((item, index) => {
                const arrayKey = parentKey ? `${parentKey}[${index}]` : `[${index}]`;
                result.push(...this.flattenObject(item, arrayKey));
            });
            return result;
        }

        for (const [key, value] of Object.entries(obj)) {
            const newKey = parentKey ? `${parentKey}.${key}` : key;

            // Special handling for detailsJson - parse and flatten it
            if (key === "detailsJson" && typeof value === "string") {
                try {
                    const parsedDetails = JSON.parse(value);
                    result.push(...this.flattenObject(parsedDetails, newKey));
                } catch (error) {
                    result.push({ key: newKey, value: String(value) });
                }
            } else {
                result.push(...this.flattenObject(value, newKey));
            }
        }

        return result;
    };

    renderTable = (entries?: WatchListEntryEsModel | WatchListEntryEsModel[] | null) => {
        if (!entries) {
            return (
                <div>
                    <label>No entries found</label>
                </div>
            );
        }

        const entryArray = Array.isArray(entries) ? entries : [entries];

        const flattenedEntries = entryArray.flatMap((entry) => this.flattenObject(entry));

        return (
            <table className="table-auto border-collapse border border-gray-400">
                <thead>
                    <tr>
                        <th className="border border-gray-400 px-2 py-1">Label</th>
                        <th className="border border-gray-400 px-2 py-1">Value</th>
                    </tr>
                </thead>
                <tbody>
                    {flattenedEntries.map((item, index) => (
                        <tr key={index}>
                            <td className="border border-gray-400 px-2 py-1" style={{ width: "50%", wordBreak: "break-word" }}>
                                {utils.makeKeyReadable(item.key)}
                            </td>
                            <td className="border border-gray-400 px-2 py-1" style={{ width: "50%", wordBreak: "break-word" }}>
                                {item.value}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    onAddressObj = (obj: UserAddress | null | undefined): UserAddress => {
        if (obj === null || obj === undefined) {
            return {
                countryId: "",
                city: "",
                stateProvinceCounty: "",
                zipCode: "",
                addressLine: "",
            };
        }
        return obj;
    };

    onAddressUpdate = (address: UserAddress) => {
        const userDataDetail = this.state.individual;
        const normalizedAddressLine = address.addressLine?.split(",")[0].trim() ?? "";

        const objToPost: UserAddress = {
            countryId: address.countryId,
            city: address.city,
            stateProvinceCounty: address.stateProvinceCounty,
            zipCode: address.zipCode,
            addressLine: normalizedAddressLine,
        } as UserAddress;

        if (address.type === "correspondence") {
            userDataDetail!.correspondenceAddress = objToPost;
        } else {
            userDataDetail!.residenceAddress = objToPost;
        }

        this.setState({ individual: userDataDetail, isAddressDetailVisible: false });
    };

    onAddressDetailsModalClose = async () => {
        this.setState({ isAddressDetailVisible: false });
    };

    onFieldUpdate = (fieldName: string, value: any) => {
        const individualData = this.state.individual as any;
        individualData[fieldName] = value;
        this.setState({ individual: individualData });
    };

    onDownloadClick = async (fileStorageId: string, secondaryLabel: string): Promise<string> => {
        this.setState({ isLoading: true });
        const imagePath = await fileService.GetFile(fileStorageId);

        if (!imagePath.success) {
            toastService.error(imagePath.message);
            return "";
        }

        const url = utils.appendBase64Data(imagePath.data, fileStorageId);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", secondaryLabel);
        document.body.appendChild(link);
        link.click();
        this.setState({ isLoading: false });
        return "ok";
    };

    onSubmitComment = async (comments: KycSubmissionComment[]) => {
        this.setState({ kycComments: comments });
    };

    onSubmitKycDocuments = async (documents: DocumentFile[]) => {
        this.setState({ kycDocuments: documents });
    };

    renderAddress = (rowData: UserAddress | null | undefined) => {
        if (rowData)
            return (
                <span>
                    {rowData?.addressLine} {rowData?.city} {rowData?.stateProvinceCounty} {rowData?.zipCode}{" "}
                    {utils.getCountryName(rowData?.countryId)}
                </span>
            );
    };

    getRiskTag = (riskLevel: number) => {
        switch (riskLevel) {
            case 1: //'Low risk':
                return <Tag className="mr-2" icon={<Check size={14} />} severity="success" value="Low risk"></Tag>;
            case 2: //'Average':
                return <Tag className="mr-2" icon={<Info size={14} />} severity="info" value="Average risk"></Tag>;
            case 3: //'High':
                return <Tag className="mr-2" icon={<AlertTriangle size={14} />} severity="warning" value="High risk"></Tag>;
            case 4: //'Critical':
                return <Tag icon={<X size={14} />} severity="danger" value="Critical risk"></Tag>;
            default:
                return null;
        }
    };

    renderRiskGrade = (riskGrade: number) => {
        const items = [
            {
                label: "Low",
                template: (item: any, options: any) => (
                    <a className={options.className} onClick={options.onClick}>
                        {riskGrade === 1 && <Check size={14} className="mr-1" />}
                        <span className={options.labelClassName}>{item.label}</span>
                    </a>
                ),
            },
            {
                label: "Average",
                template: (item: any, options: any) => (
                    <a className={options.className} onClick={options.onClick}>
                        {riskGrade === 2 && <Check size={14} className="mr-1" />}
                        <span className={options.labelClassName}>{item.label}</span>
                    </a>
                ),
            },
            {
                label: "High",
                template: (item: any, options: any) => (
                    <a className={options.className} onClick={options.onClick}>
                        {riskGrade === 3 && <Check size={14} className="mr-1" />}
                        <span className={options.labelClassName}>{item.label}</span>
                    </a>
                ),
            },
            {
                label: "Critical",
                template: (item: any, options: any) => (
                    <a className={options.className} onClick={options.onClick}>
                        {riskGrade === 4 && <Check size={14} className="mr-1" />}
                        <span className={options.labelClassName}>{item.label}</span>
                    </a>
                ),
            },
        ];
        const selectedIndex = riskGrade - 1;
        //return <Steps model={items} activeIndex={2} readOnly={true} />
        return <TabMenu model={items} activeIndex={selectedIndex} onChange={() => false} />;
    };

    render() {
        if (this.props.submission == null) {
            return <div></div>;
        }

        const isReadOnly = this.state.isReadOnly;
        return (
            <>
            {this.state.lightboxUrl && ReactDOM.createPortal(
                <div
                    onClick={() => this.setState({ lightboxUrl: null })}
                    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 999999, display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out" }}
                >
                    <img src={this.state.lightboxUrl} alt="preview" style={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: "6px", boxShadow: "0 4px 32px rgba(0,0,0,0.6)" }} />
                </div>,
                document.body
            )}
            <Dialog
                header="Individual Scorecard"
                visible={true}
                style={{ width: "92vw" }}
                modal
                onHide={this.props.onHide}
                pt={{
                    content: {
                        className: "max-h-[80vh]",
                    },
                }}
            >
                <Fragment>
                    {this.state.isAddressDetailVisible && (
                        <AddUserAddress
                            onHide={this.onAddressDetailsModalClose}
                            address={this.state.selectedAddress!}
                            countries={this.countries}
                            onAddressUpdate={this.onAddressUpdate}
                        />
                    )}


                    {/* Compliance Identity Review Dialog */}
                    <Dialog
                        header="Fill National Identity Data"
                        visible={this.state.showComplianceDialog}
                        style={{ width: "88vw", maxWidth: "1400px" }}
                        contentStyle={{ overflowY: "auto", maxHeight: "75vh" }}
                        modal
                        onHide={() => this.setState({ showComplianceDialog: false, ninError: "", pinError: "" })}
                    >
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                            {/* NIN / PIN row */}
                            <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", padding: "16px", background: "#f8f9fa" }}>
                                <h6 style={{ marginBottom: "14px", fontWeight: 600 }}>Identification Numbers</h6>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "flex-end" }}>
                                    <div style={{ flex: "1 1 220px" }}>
                                        <Label style={{ fontWeight: 500, display: "block", marginBottom: "4px" }}>
                                            National ID Number <span style={{ color: "#dc3545" }}>*</span>
                                        </Label>
                                        <InputText
                                            value={this.state.ninInput}
                                            onChange={(e) => this.setState({ ninInput: e.target.value, ninError: "" })}
                                            placeholder="Letters and digits, 2–20 characters"
                                            style={{ width: "100%", borderColor: this.state.ninError ? "#dc3545" : undefined }}
                                        />
                                        {this.state.ninError && <small style={{ color: "#dc3545", display: "block", marginTop: "4px" }}>{this.state.ninError}</small>}
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingBottom: "2px" }}>
                                        <Checkbox inputId="dlg-ninChecked" checked={this.state.dlgNinChecked} onChange={(e) => this.setState({ dlgNinChecked: !!e.checked, ninError: "" })} />
                                        <label htmlFor="dlg-ninChecked" style={{ cursor: "pointer", margin: 0 }}>NIN reviewed <span style={{ color: "#dc3545" }}>*</span></label>
                                    </div>
                                    <div style={{ flex: "1 1 220px" }}>
                                        <Label style={{ fontWeight: 500, display: "block", marginBottom: "4px" }}>
                                            Personal Identification Number <span style={{ color: "#dc3545" }}>*</span>
                                        </Label>
                                        <InputText
                                            value={this.state.pinInput}
                                            onChange={(e) => this.setState({ pinInput: e.target.value, pinError: "" })}
                                            placeholder="Letters and digits, 9–20 characters"
                                            style={{ width: "100%", borderColor: this.state.pinError ? "#dc3545" : undefined }}
                                        />
                                        {this.state.pinError && <small style={{ color: "#dc3545", display: "block", marginTop: "4px" }}>{this.state.pinError}</small>}
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingBottom: "2px" }}>
                                        <Checkbox inputId="dlg-pinChecked" checked={this.state.dlgPinChecked} onChange={(e) => this.setState({ dlgPinChecked: !!e.checked, pinError: "" })} />
                                        <label htmlFor="dlg-pinChecked" style={{ cursor: "pointer", margin: 0 }}>PIN reviewed <span style={{ color: "#dc3545" }}>*</span></label>
                                    </div>
                                    <div style={{ paddingBottom: "2px" }}>
                                        <Button label="Save Compliance Review" type="button" severity="success" loading={this.state.isSavingReview} onClick={this.onSaveComplianceReview} />
                                    </div>
                                </div>
                            </div>

                            {/* MRZ Calculator */}
                            <div style={{ marginTop: "16px", border: "1px solid #dee2e6", borderRadius: "6px", padding: "14px" }}>
                                <h6 style={{ marginBottom: "12px", fontWeight: 600 }}>MRZ Identity Number Calculator</h6>
                                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "flex-end" }}>
                                    <div style={{ flex: "1 1 200px" }}>
                                        <label style={{ display: "block", fontSize: "0.85em", marginBottom: "4px", color: "#555" }}>MRZ Line 1</label>
                                        <InputText
                                            value={this.state.mrzLine1}
                                            onChange={(e) => this.setState({ mrzLine1: e.target.value, mrzResult: null })}
                                            placeholder="e.g. P<NPLOLI<<BHISMA..."
                                            style={{ width: "100%", fontFamily: "monospace", fontSize: "12px" }}
                                        />
                                    </div>
                                    <div style={{ flex: "1 1 200px" }}>
                                        <label style={{ display: "block", fontSize: "0.85em", marginBottom: "4px", color: "#555" }}>MRZ Line 2</label>
                                        <InputText
                                            value={this.state.mrzLine2}
                                            onChange={(e) => this.setState({ mrzLine2: e.target.value, mrzResult: null })}
                                            placeholder="e.g. PA3299182..."
                                            style={{ width: "100%", fontFamily: "monospace", fontSize: "12px" }}
                                        />
                                    </div>
                                    <div style={{ flex: "1 1 200px" }}>
                                        <label style={{ display: "block", fontSize: "0.85em", marginBottom: "4px", color: "#555" }}>MRZ Line 3 <span style={{ color: "#888", fontWeight: 400 }}>(optional)</span></label>
                                        <InputText
                                            value={this.state.mrzLine3}
                                            onChange={(e) => this.setState({ mrzLine3: e.target.value, mrzResult: null })}
                                            placeholder="TD1 only"
                                            style={{ width: "100%", fontFamily: "monospace", fontSize: "12px" }}
                                        />
                                    </div>
                                    <div style={{ paddingBottom: "2px" }}>
                                        <Button
                                            label="Calculate"
                                            type="button"
                                            severity="info"
                                            loading={this.state.mrzCalculating}
                                            onClick={this.calculateMrz}
                                            disabled={!this.state.mrzLine1 && !this.state.mrzLine2}
                                        />
                                    </div>
                                </div>
                                {this.state.mrzResult !== null && (
                                    <div style={{ marginTop: "12px", display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", background: this.state.mrzResult ? "#f0fdf4" : "#fff8f0", border: `1px solid ${this.state.mrzResult ? "#86efac" : "#fcd34d"}`, borderRadius: "6px" }}>
                                        <span style={{ fontSize: "0.85em", color: "#555" }}>Extracted Identity Number:</span>
                                        {this.state.mrzResult ? (
                                            <span style={{ fontFamily: "monospace", fontWeight: 700, fontSize: "1em", color: "#166534", letterSpacing: "1px" }}>
                                                {this.state.mrzResult}
                                            </span>
                                        ) : (
                                            <span style={{ fontSize: "0.85em", color: "#92400e" }}>Could not extract a valid identity number from the provided MRZ lines.</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Side-by-side: JSON left, Documents right */}
                            <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>

                                {/* LEFT — Onfido JSON */}
                                <div style={{ flex: "1 1 0", minWidth: 0, border: "1px solid #dee2e6", borderRadius: "6px", padding: "14px", display: "flex", flexDirection: "column" }}>
                                    <h6 style={{ marginBottom: "10px", fontWeight: 600 }}>Onfido KYC Metadata</h6>
                                    {(() => {
                                        try {
                                            const parsed = JSON.parse(this.props.submission.externalIdentificationMetadata!);
                                            const tasks: any[] = parsed?.tasks ?? [];
                                            const task = tasks.find((t: any) => t.task_def_id === "document_check_with_address_information");
                                            const properties = task?.output?.properties ?? null;
                                            if (properties) {
                                                return (
                                                    <div style={{ overflowY: "auto", overflowX: "auto", maxHeight: "35vh", borderRadius: "4px", background: "#fafafa", padding: "8px" }}>
                                                        <ReactJson
                                                            src={properties}
                                                            theme="rjv-default"
                                                            collapsed={false}
                                                            displayDataTypes={false}
                                                            displayObjectSize={false}
                                                            enableClipboard={true}
                                                            style={{ fontSize: "12px", fontFamily: "monospace", wordBreak: "break-all" }}
                                                        />
                                                    </div>
                                                );
                                            }
                                        } catch { }
                                        return <p style={{ color: "#888", margin: 0 }}>No document check metadata available.</p>;
                                    })()}
                                </div>

                                {/* RIGHT — Documents */}
                                <div style={{ flex: "1 1 0", minWidth: 0, border: "1px solid #dee2e6", borderRadius: "6px", padding: "14px" }}>
                                    <h6 style={{ marginBottom: "10px", fontWeight: 600 }}>KYC Documents</h6>
                                    {this.state.complianceDocsLoading ? (
                                        <p style={{ color: "#888" }}>Loading documents…</p>
                                    ) : this.state.complianceDocuments.length === 0 ? (
                                        <p style={{ color: "#888" }}>No documents found.</p>
                                    ) : (
                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", overflowY: "auto", maxHeight: "35vh" }}>
                                            {this.state.complianceDocuments.map((doc) => {
                                                const url = this.state.docUrls[doc.fileStorageId];
                                                const isPdf = doc.fileName?.toLowerCase().endsWith(".pdf");
                                                return (
                                                    <div
                                                        key={doc.fileStorageId}
                                                        style={{ width: "140px", border: "1px solid #dee2e6", borderRadius: "6px", overflow: "hidden", cursor: "pointer", background: "#fff" }}
                                                        title={doc.fileName}
                                                        onClick={() => {
                                                            if (!url) return;
                                                            if (isPdf) {
                                                                const a = document.createElement("a");
                                                                a.href = url;
                                                                a.download = doc.fileName;
                                                                a.click();
                                                            } else {
                                                                this.setState({ lightboxUrl: url });
                                                            }
                                                        }}
                                                    >
                                                        {!url ? (
                                                            <div style={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", color: "#aaa", fontSize: "12px" }}>Loading…</div>
                                                        ) : isPdf ? (
                                                            <div style={{ height: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#fff8f0", gap: "6px" }}>
                                                                <span style={{ fontSize: "32px" }}>📄</span>
                                                                <span style={{ fontSize: "11px", color: "#888" }}>Click to download</span>
                                                            </div>
                                                        ) : (
                                                            <img src={url} alt={doc.fileName} style={{ width: "100%", height: "100px", objectFit: "cover", display: "block" }} />
                                                        )}
                                                        <div style={{ padding: "6px 8px", fontSize: "11px", color: "#555", wordBreak: "break-word", borderTop: "1px solid #f0f0f0" }}>
                                                            {doc.fileName}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </Dialog>

                    {/* Edit Country Parameters Dialog */}
                    <Dialog
                        header="Edit Country Parameters"
                        visible={this.state.isEditingCountryOverride}
                        style={{ width: "50vw" }}
                        modal
                        onHide={() => this.onCancelEditCountryOverride()}
                    >
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                                <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                                    <Label for="enrollCountryCodeEdit" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                        Country of Registration
                                    </Label>
                                    <ExtendedDropdown
                                        value={this.state.editEnrollCountryCode}
                                        options={this.countries}
                                        onChange={(e) => this.setState({ editEnrollCountryCode: e.value })}
                                        filter
                                        filterBy="label"
                                        placeholder="Select a Country"
                                        required={true}
                                        name="Country of Registration"
                                        onValidStatusChanged={(value: boolean) => this.validationErrors.set("enrollCountryCode", value)}
                                        valueTemplate={this.selectedCountryOverrideTemplate}
                                        itemTemplate={this.countryOverrideOptionTemplate}
                                    />
                                </div>

                                <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                                    <Label for="ipCountryCodeEdit" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                        IP country
                                    </Label>
                                    <ExtendedDropdown
                                        value={this.state.editIpCountryCode}
                                        options={this.countries}
                                        onChange={(e) => this.setState({ editIpCountryCode: e.value })}
                                        filter
                                        filterBy="label"
                                        placeholder="Select a Country"
                                        required={true}
                                        name="IP country"
                                        onValidStatusChanged={(value: boolean) => this.validationErrors.set("ipCountryCode", value)}
                                        valueTemplate={this.selectedCountryOverrideTemplate}
                                        itemTemplate={this.countryOverrideOptionTemplate}
                                    />
                                </div>

                                <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                                    <Label for="geoLocationCountryCodeEdit" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                        Geolocation
                                    </Label>
                                    <ExtendedDropdown
                                        value={this.state.editGeoLocationCountryCode}
                                        options={this.countries}
                                        onChange={(e) => this.setState({ editGeoLocationCountryCode: e.value })}
                                        filter
                                        filterBy="label"
                                        placeholder="Select a Country"
                                        required={true}
                                        name="Geolocation"
                                        onValidStatusChanged={(value: boolean) => this.validationErrors.set("geoLocationCountryCode", value)}
                                        valueTemplate={this.selectedCountryOverrideTemplate}
                                        itemTemplate={this.countryOverrideOptionTemplate}
                                    />
                                </div>
                            </div>

                            <div>
                                <Label for="countryOverrideReason" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                    Reason for country override
                                </Label>
                                <InputTextarea
                                    value={this.state.countryOverrideReason}
                                    className={cx("form-control", this.state.countryOverrideReasonError ? "p-invalid" : "")}
                                    id="countryOverrideReason"
                                    placeholder="Required if Country of Registration, IP country or Geolocation was changed"
                                    maxLength={MAX_COUNTRY_OVERRIDE_REASON_LENGTH}
                                    rows={2}
                                    style={{ width: "100%", resize: "vertical" }}
                                    onChange={(e) => this.onCountryOverrideReasonChange(e.target.value)}
                                />
                                {this.state.countryOverrideReasonError && (
                                    <small className="p-error block">{this.state.countryOverrideReasonError}</small>
                                )}
                            </div>

                            <div style={{ display: "flex", gap: "8px" }}>
                                <Button
                                    label="Done"
                                    type="button"
                                    severity="success"
                                    icon={<Check size={14} />}
                                    onClick={() => this.onToggleEditCountryOverride()}
                                />
                                <Button
                                    label="Cancel"
                                    type="button"
                                    severity="secondary"
                                    icon={<X size={14} />}
                                    onClick={() => this.onCancelEditCountryOverride()}
                                />
                            </div>
                        </div>
                    </Dialog>

                    <Dialog
                        header="Dow Jones Compliance Found Records"
                        visible={this.state.isDowJonesComplianceDetailsVisible}
                        style={{ width: "40vw" }}
                        onHide={() => this.setState({ isDowJonesComplianceDetailsVisible: false })}
                    >
                        <div>
                            <AppCard className="mb-3">
                                <AppCard.Body
                                    className="max-h-[60vh] overflow-y-auto"
                                >
                                    {this.renderDowJonesComplianceResult()}
                                </AppCard.Body>
                            </AppCard>
                        </div>
                    </Dialog>

                    <PageLayout noTitle>
                                    <AppCard className="mb-3">
                                        <AppCard.Body>
                                            {this.state.submission.status === KYC_STATUS_UNDER_REVIEW
                                                && this.state.submission.reason === NEW_DOCUMENT_UPLOADED_REASON && (
                                                <div style={{ background: "#e7f1ff", border: "1px solid #4a90e2", borderRadius: "6px", padding: "12px 16px", marginBottom: "16px", display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                                    <Info size={20} style={{ color: "#1d4e89", flexShrink: 0, marginTop: "2px" }} />
                                                    <div>
                                                        <strong style={{ color: "#1d4e89" }}>New Customer Document Uploaded</strong>
                                                        <p style={{ margin: "4px 0 0", color: "#1d4e89", fontSize: "14px" }}>
                                                            This submission moved back to Under Review because the customer uploaded a new additional document. See the
                                                            <strong> Additional Documents</strong> section below to review it.
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {this.complianceReviewRequired && (
                                                <div style={{ background: FLAG_HIGHLIGHT_BACKGROUND, border: `1px solid ${FLAG_HIGHLIGHT_BORDER_COLOR}`, borderRadius: "6px", padding: "12px 16px", marginBottom: "16px", display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                                    <AlertTriangle size={20} style={{ color: "#856404", flexShrink: 0, marginTop: "2px" }} />
                                                    <div>
                                                        <strong style={{ color: "#856404" }}>Identity Data Review Required</strong>
                                                        <p style={{ margin: "4px 0 0", color: "#856404", fontSize: "14px" }}>
                                                            One or more identity fields (National ID Number / Personal Identification Number) require review.
                                                            Click <strong>Fill National Identity Data</strong> to verify the values — use the MRZ calculator if needed — then confirm both checkboxes and save before approving.
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            <Row>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="MerchantGroupId" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Merchant Group Id
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.merchantGroupId.toString()}
                                                        className={"form-control"}
                                                        id="MerchantGroupId"
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="MerchantGroup" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Merchant Group Name
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.merchantGroup}
                                                        className={"form-control"}
                                                        id="MerchantGroup"
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="MerchantId" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Merchant Id
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.merchantId.toString()}
                                                        className={"form-control"}
                                                        id="MerchantId"
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="Merchant" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Merchant Name
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.merchant}
                                                        className={"form-control"}
                                                        id="Merchant"
                                                        readOnly={true}
                                                    />
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="SubmissionId" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Submission Id
                                                    </Label>
                                                    <InputText
                                                        value={this.state.submission?.id?.toString() || ""}
                                                        className={"form-control"}
                                                        id="SubmissionId"
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                {/* <Col className="p-5" sm={12} md={4} lg={4} xl={3}> */}
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="IndividualId" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        User Id
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.id.toString()}
                                                        className={"form-control"}
                                                        id="IndividualId"
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="CbsId" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        CBS Id
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.cbsId?.toString() || ""}
                                                        className={"form-control"}
                                                        id="CbsId"
                                                        readOnly={true}
                                                    />
                                                </Col>

                                                <Col sm={12} className="p-2.5">
                                                    <div className="border border-solid border-[#d0d5dd] bg-[#fafafa] dark:border-neutral-600 dark:bg-transparent" style={{ borderRadius: "8px", padding: "12px 14px", display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-start" }}>
                                                        <div style={{ flex: "1 1 160px", minWidth: 0 }}>
                                                            <Label for="RegiteringCountry" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                Country of Registration
                                                            </Label>
                                                            <InputText
                                                                value={utils.getCountryName(this.state.individual?.enrollCountryCode ?? "None")}
                                                                className={"form-control"}
                                                                id="RegiteringCountry"
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                        <div style={{ flex: "1 1 160px", minWidth: 0 }}>
                                                            <Label for="ipCountryCode" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                IP country
                                                            </Label>
                                                            <InputText
                                                                value={utils.getCountryName(this.state.individual?.ipCountryCode ?? "None")}
                                                                className={"form-control"}
                                                                id="ipCountryCode"
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                        <div style={{ flex: "1 1 160px", minWidth: 0 }}>
                                                            <Label for="geoLocationCountryCode" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                Geolocation
                                                            </Label>
                                                            <InputText
                                                                value={utils.getCountryName(this.state.individual?.geoLocationCountryCode ?? "None")}
                                                                className={"form-control"}
                                                                id="geoLocationCountryCode"
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                        {this.canEditCountryOverrides() && (
                                                            <div style={{ flexShrink: 0 }}>
                                                                <label style={{ display: "block", visibility: "hidden", fontSize: "1em" }}>&nbsp;</label>
                                                                <Button
                                                                    label="Edit Country Parameters"
                                                                    type="button"
                                                                    severity="info"
                                                                    icon={<Pencil size={14} />}
                                                                    onClick={() => this.onToggleEditCountryOverride()}
                                                                    style={{ whiteSpace: "nowrap" }}
                                                                />
                                                            </div>
                                                        )}

                                                        {(isKYCAssessAllowed() || this.canEditCountryOverrides()) && (this.state.individual?.riskCountryOverrideHistory?.length ?? 0) > 0 && (
                                                            <div style={{ flex: "1 1 100%", minWidth: 0, marginTop: "4px" }}>
                                                                <Label style={{ fontSize: "0.9em", color: "#666", whiteSpace: "nowrap" }}>
                                                                    Override History ({this.state.individual!.riskCountryOverrideHistory!.length})
                                                                </Label>
                                                                <div className="border border-solid border-[#e5e7eb] bg-white dark:border-neutral-700 dark:bg-neutral-900" style={{ maxHeight: "140px", overflowY: "auto", borderRadius: "6px" }}>
                                                                    {this.state.individual!.riskCountryOverrideHistory!.map((entry) => (
                                                                        <div
                                                                            key={entry.id}
                                                                            className={cx("border-b border-solid border-[#f0f0f0] dark:border-neutral-800", entry.isInitialSnapshot && "bg-[#f8f9fa] dark:bg-neutral-800")}
                                                                            style={{
                                                                                padding: "6px 10px",
                                                                                fontSize: "0.85em",
                                                                                fontStyle: entry.isInitialSnapshot ? "italic" : undefined,
                                                                            }}
                                                                        >
                                                                            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                                <span>
                                                                                    <strong>Country of Registration:</strong> {utils.getCountryName(entry.enrollCountryCodeOverride)}
                                                                                </span>
                                                                                <span>
                                                                                    <strong>IP:</strong> {utils.getCountryName(entry.ipCountryCodeOverride)}
                                                                                </span>
                                                                                <span>
                                                                                    <strong>Geo:</strong> {utils.getCountryName(entry.geoLocationCountryCodeOverride)}
                                                                                </span>
                                                                            </div>
                                                                            <div style={{ color: "#666" }}>
                                                                                {entry.isInitialSnapshot
                                                                                    ? `${moment.utc(entry.createdAt).local().format("DD/MM/YYYY HH:mm:ss")} — pre-override values, not a manual edit`
                                                                                    : `${moment.utc(entry.createdAt).local().format("DD/MM/YYYY HH:mm:ss")} — ${entry.createdByOperatorEmail || (entry.createdByOperatorId != null ? `Operator #${entry.createdByOperatorId}` : "Operator (account deleted)")}`}
                                                                            </div>
                                                                            {!entry.isInitialSnapshot && <div>{entry.reason}</div>}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="FirstName" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        First Name
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.firstName}
                                                        className={"form-control"}
                                                        id="FirstName"
                                                        onChange={(e) => this.onFieldUpdate("firstName", e.target.value)}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="LastName" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Last Name
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.lastName}
                                                        className={"form-control"}
                                                        id="LastName"
                                                        onChange={(e) => this.onFieldUpdate("lastName", e.target.value)}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="nonLatinFirstName" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Non-Latin First Name
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.nonLatinFirstName}
                                                        className={"form-control"}
                                                        id="nonLatinFirstName"
                                                        onChange={(e) => this.onFieldUpdate("nonLatinFirstName", e.target.value)}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={2}>
                                                    <Label for="nonLatinLastName" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Non-Latin Last Name
                                                    </Label>
                                                    <InputText
                                                        value={this.state.individual?.nonLatinLastName}
                                                        className={"form-control"}
                                                        id="nonLatinLastName"
                                                        onChange={(e) => this.onFieldUpdate("nonLatinLastName", e.target.value)}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Col>

                                                <Col sm={12} className="p-2.5">
                                                    <div className="border border-solid border-[#d0d5dd] bg-[#fafafa] dark:border-neutral-600 dark:bg-transparent" style={{ borderRadius: "8px", padding: "12px 14px", display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-start" }}>
                                                        <div style={{ flex: "1 1 160px", minWidth: 0 }}>
                                                            <Label for="NationalIdNumber" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                National Id Number
                                                            </Label>
                                                            <InputText
                                                                value={this.state.individual?.nationalIdNumber}
                                                                className={"form-control"}
                                                                id="NationalIdNumber"
                                                                readOnly={true}
                                                            />
                                                            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "6px" }}>
                                                                <Checkbox inputId="main-ninChecked" checked={this.state.ninChecked} disabled={true} />
                                                                <label htmlFor="main-ninChecked" style={{ margin: 0, fontSize: "0.85em", color: "#666" }}>NIN reviewed</label>
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                                                            <Label for="personalIdentificationNumber" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                Identification Number
                                                            </Label>
                                                            <InputText
                                                                value={this.state.individual?.personalIdentificationNumber}
                                                                className={"form-control"}
                                                                id="personalIdentificationNumber"
                                                                readOnly={true}
                                                            />
                                                            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "6px" }}>
                                                                <Checkbox inputId="main-pinChecked" checked={this.state.pinChecked} disabled={true} />
                                                                <label htmlFor="main-pinChecked" style={{ margin: 0, fontSize: "0.85em", color: "#666" }}>PIN reviewed</label>
                                                            </div>
                                                        </div>
                                                        <div style={{ flexShrink: 0 }}>
                                                            <label style={{ display: "block", visibility: "hidden", fontSize: "1em" }}>&nbsp;</label>
                                                            <Button
                                                                label="Fill National Identity Data"
                                                                type="button"
                                                                severity={this.complianceReviewRequired ? "warning" : "info"}
                                                                icon={<Pencil size={14} />}
                                                                onClick={this.openComplianceDialog}
                                                                style={{ whiteSpace: "nowrap" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>

                                                {/* The section hides itself for EU/EEA nationals and while its GET is in flight. */}
                                                {this.state.individual && (
                                                    <ResidencePermitSection
                                                        individualId={this.state.individual.id}
                                                        submissionId={this.props.submission.id}
                                                        onLoaded={this.onResidencePermitLoaded}
                                                    />
                                                )}

                                                <Col className="p-2.5" sm={12} md={4} lg={4} xl={6}>
                                                    <Label for="AddressOfResidence" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Address of Residence
                                                    </Label>
                                                    <div className="square border rounded border-2 p-2">
                                                        {this.renderAddress(this.state.individual?.residenceAddress)}
                                                        <button
                                                            type="button"
                                                            className="inline-flex items-center justify-center p-1 rounded hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors float-right"
                                                            tabIndex={0}
                                                            onClick={() =>
                                                                this.addorEditAddress(
                                                                    "residence",
                                                                    this.onAddressObj(this.state.individual?.residenceAddress),
                                                                )
                                                            }
                                                            disabled={isReadOnly}
                                                        >
                                                            <Pencil size={16} className="text-neutral-500" />
                                                        </button>
                                                    </div>
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={4} lg={4} xl={6}>
                                                    <Label for="AddressOfCorrespondence" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Address of Correspondence
                                                    </Label>
                                                    <div className="square border rounded border-2 p-2">
                                                        {this.renderAddress(this.state.individual?.correspondenceAddress)}
                                                        <button
                                                            type="button"
                                                            className="inline-flex items-center justify-center p-1 rounded hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors float-right"
                                                            tabIndex={0}
                                                            onClick={() =>
                                                                this.addorEditAddress(
                                                                    "correspondence",
                                                                    this.onAddressObj(this.state.individual?.correspondenceAddress),
                                                                )
                                                            }
                                                            disabled={isReadOnly}
                                                        >
                                                            <Pencil size={16} className="text-neutral-500" />
                                                        </button>
                                                    </div>
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={4} lg={8} xl={3}>
                                                    <Label for="mainActivity" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Main activity
                                                    </Label>
                                                    <ExtendedDropdown
                                                        style={{ display: "flex" }}
                                                        value={this.state.individual?.mainActivityCode}
                                                        options={this.mainActivities}
                                                        onChange={(e) => this.onFieldUpdate("mainActivityCode", e.value)}
                                                        filter
                                                        filterBy="label"
                                                        required={true}
                                                        name="Main activity"
                                                        onValidStatusChanged={(value: boolean) => this.validationErrors.set("mainActivity", value)}
                                                        disabled={isReadOnly}
                                                    />
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={4} lg={8} xl={3}>
                                                    <Label for="SourceofFunds" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Source of Funds
                                                    </Label>
                                                    <ExtendedDropdown
                                                        style={{ display: "flex" }}
                                                        value={this.state.individual?.sourceOfFundId.toString()}
                                                        options={this.sourceOfFunds}
                                                        onChange={(e) => this.onFieldUpdate("sourceOfFundId", e.value)}
                                                        filter
                                                        filterBy="label"
                                                        required={true}
                                                        name="Source Of Funds"
                                                        onValidStatusChanged={(value: boolean) => this.validationErrors.set("sourceOfFunds", value)}
                                                        disabled={isReadOnly}
                                                    />
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={4} lg={8} xl={3}>
                                                    <Label for="financingMethods" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Financing method
                                                    </Label>
                                                    <ExtendedDropdown
                                                        style={{ display: "flex" }}
                                                        value={this.state.individual?.financingMethodCode}
                                                        options={this.financingMethods}
                                                        onChange={(e) => this.onFieldUpdate("financingMethodCode", e.value)}
                                                        filter
                                                        filterBy="label"
                                                        required={true}
                                                        name="Financing method"
                                                        onValidStatusChanged={(value: boolean) =>
                                                            this.validationErrors.set("financingMethods", value)
                                                        }
                                                        disabled={isReadOnly}
                                                    />
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={4} lg={8} xl={3}>
                                                    <Label for="accountPurpose" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Account purpose
                                                    </Label>
                                                    <ExtendedDropdown
                                                        style={{ display: "flex" }}
                                                        value={this.state.individual?.accountPurposeCode}
                                                        options={this.accountPurposes}
                                                        onChange={(e) => this.onFieldUpdate("accountPurposeCode", e.value)}
                                                        filter
                                                        filterBy="label"
                                                        required={true}
                                                        name="Account purpose"
                                                        onValidStatusChanged={(value: boolean) => this.validationErrors.set("accountPurposes", value)}
                                                        disabled={isReadOnly}
                                                    />
                                                </Col>

                                                {/* AuthX at the top of this section */}
                                                <Col className="p-2.5" sm={12} md={4} lg={2} xl={1}>
                                                    <Label for="DocumentAuthenticity" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        AuthX
                                                    </Label>
                                                    <br />
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.individual?.documentsAuthenticatedByThirdParty}
                                                        readOnly={true}
                                                        id="DocumentAuthenticity"
                                                    ></input>
                                                </Col>

                                                {/* Automated Screening Results */}
                                                <Col sm={12}>
                                                    <div
                                                        style={flagSectionStyle(
                                                            !!this.state.individual?.isPEPCalculated || !!this.state.individual?.isSIPCalculated
                                                        )}
                                                        data-testid="automated-screening-section"
                                                    >
                                                        <Label style={{ fontWeight: "bold", fontSize: "1.1em" }}>Automated Screening Results</Label>
                                                        <Row>
                                                            <Col className="p-2.5" sm={12} md={2} lg={2} xl={1}>
                                                                <Label for="IsPEPCalculated" style={{ ...flagLabelStyle, fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                    Is PEP
                                                                </Label>
                                                                <br />
                                                                <input
                                                                    type="checkbox"
                                                                    style={flagCheckboxStyle}
                                                                    checked={!!this.state.individual?.isPEPCalculated}
                                                                    readOnly={true}
                                                                    tabIndex={-1}
                                                                    aria-disabled={true}
                                                                    id="IsPEPCalculated"
                                                                ></input>
                                                            </Col>
                                                            <Col className="p-2.5" sm={12} md={2} lg={2} xl={2}>
                                                                <Label for="IsSIPCalculated" style={{ ...flagLabelStyle, fontSize: "1em", whiteSpace: "nowrap" }}>
                                                                    Is SIP
                                                                </Label>
                                                                <br />
                                                                <input
                                                                    type="checkbox"
                                                                    style={flagCheckboxStyle}
                                                                    checked={!!this.state.individual?.isSIPCalculated}
                                                                    readOnly={true}
                                                                    tabIndex={-1}
                                                                    aria-disabled={true}
                                                                    id="IsSIPCalculated"
                                                                ></input>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>

                                                {/* Customer PEP Declaration (Onboarding) */}
                                                <CustomerPepDeclaration declaration={this.state.individual?.pepDeclaration} />

                                                {/* Compliance Final Decision */}
                                                <Col sm={12}>
                                                    <Label style={{ fontWeight: "bold", fontSize: "1.1em" }}>Compliance Final Decision</Label>
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={2} lg={2} xl={1}>
                                                    <Label for="IsPEP" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Is PEP
                                                    </Label>
                                                    <br />
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.individual?.isPEP}
                                                        onChange={(e) => this.onFieldUpdate("isPEP", e.target.checked)}
                                                        readOnly={false}
                                                        id="IsPEP"
                                                    ></input>
                                                </Col>
                                                <Col className="p-2.5" sm={12} md={10} lg={10} xl={10}>
                                                    <Label for="IsSIP" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Is SIP
                                                    </Label>
                                                    <br />
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.individual?.isSIP}
                                                        onChange={(e) => this.onFieldUpdate("isSIP", e.target.checked)}
                                                        readOnly={false}
                                                        id="IsSIP"
                                                    ></input>
                                                </Col>

                                                {/* Magnifying glass button */}
                                                <Col className="p-2.5" sm={12} md={1} lg={3} xl={3}>
                                                    <Label for="DJview" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Found Record (Manual)
                                                    </Label>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="inline-flex items-center justify-center p-1 rounded hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors float-left"
                                                            tabIndex={0}
                                                            onClick={() => this.showDowJonesComplianceDetail()}
                                                            disabled={isReadOnly}
                                                        >
                                                            <Search size={16} className="text-neutral-500" />
                                                        </button>
                                                    </div>
                                                </Col>

                                                {/* New editable text inputs */}
                                                <Col className="p-2.5" sm={12} md={3} lg={3} xl={3}>
                                                    <Label for="minimumMatchingPercentageSIP" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Minimum matching percentage (SIP)
                                                    </Label>
                                                    <input
                                                        type="number"
                                                        id="minimumMatchingPercentageSIP"
                                                        className="form-control"
                                                        min={0}
                                                        max={100}
                                                        value={this.state.minimumMatchingPercentageSIP ?? ""}
                                                        onKeyDown={(e) => {
                                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            let value = e.target.value === "" ? null : Number(e.target.value);

                                                            if (value != null) {
                                                                if (value < 0) value = 0;
                                                                if (value > 100) value = 100;
                                                            }

                                                            this.setState({ minimumMatchingPercentageSIP: value });
                                                        }}
                                                        placeholder="0-100"
                                                    />
                                                </Col>

                                                <Col className="p-2.5" sm={12} md={3} lg={3} xl={3}>
                                                    <Label for="minimumMatchingPercentagePEP" style={{ fontSize: "1em", whiteSpace: "nowrap" }}>
                                                        Minimum matching percentage (PEP)
                                                    </Label>
                                                    <input
                                                        type="number"
                                                        id="minimumMatchingPercentagePEP"
                                                        className="form-control"
                                                        min={0}
                                                        max={100}
                                                        value={this.state.minimumMatchingPercentagePEP ?? ""}
                                                        onKeyDown={(e) => {
                                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            let value = e.target.value === "" ? null : Number(e.target.value);

                                                            if (value != null) {
                                                                if (value < 0) value = 0;
                                                                if (value > 100) value = 100;
                                                            }

                                                            this.setState({ minimumMatchingPercentagePEP: value });
                                                        }}
                                                        placeholder="0-100"
                                                    />
                                                </Col>
                                            </Row>

                                                    <AppCard>
                                                        <AppCard.Header title="Documents" />
                                                        <AppCard.Body>
                                                            <AddManualKyc
                                                                submissionId={this.state.submission.id}
                                                                submitToOwner={this.onSubmitKycDocuments}
                                                            />
                                                        </AppCard.Body>
                                                    </AppCard>

                                                    {isIndividualDocumentsViewAllowed() && this.state.documentsFeatureEnabled && this.state.individual && (
                                                        <AppCard>
                                                            <AppCard.Header title="Additional Documents" />
                                                            <AppCard.Body>
                                                                <UserDocumentsComponent individualId={this.state.individual.id} />
                                                            </AppCard.Body>
                                                        </AppCard>
                                                    )}

                                                    <AppCard>
                                                        <AppCard.Header title="Comments" />
                                                        <AppCard.Body>
                                                            <KycSubmissionCommentForm
                                                                submissionId={this.state.submission.id}
                                                                comments={this.state.kycComments}
                                                                submitToOwner={this.onSubmitComment}
                                                            />
                                                        </AppCard.Body>
                                                    </AppCard>

                                            {isKYCApproveAllowed() && (
                                                        <AppCard>
                                                            <AppCard.Header title="Risk result" />
                                                            <AppCard.Body>
                                                                <Row className="p-5">
                                                                    <Col className="p-5" sm={12} md={4} lg={4} xl={3}>
                                                                        <p>Risk score {this.state.individual?.riskScore}.</p>
                                                                        {/* <p>Risk grade {this.state.individual?.riskGrade}.</p> */}
                                                                        {/* <Label for="RiskScore">Risk score</Label>
                                                                <InputText value={this.state.individual?.riskScore} className={"form-control"} id="RiskScore" readOnly={true} /> */}
                                                                    </Col>
                                                                    {/* <Col className="p-5" sm={12} md={4} lg={4} xl={3}>
                                                                {this.getRiskTag(this.state.individual?.riskGrade ?? 0)}
                                                            </Col>     */}
                                                                    {this.renderRiskGrade(this.state.individual?.riskGrade ?? 4)}
                                                                </Row>
                                                            </AppCard.Body>
                                                        </AppCard>
                                            )}

                                            <Row style={{ padding: "20px", gap: "1.25rem" }}>
                                                {isKYCAssessAllowed() && (
                                                    // <Col style={{ textAlign: "center" }} className="d-flex flex-row">
                                                    <Button
                                                        label={"Submit"}
                                                        type="button"
                                                        icon={<Check size={16} />}
                                                        severity="success"
                                                        disabled={this.state.disableSubmitBtn}
                                                        onClick={() => this.onSubmit()}
                                                    >
                                                        {this.state.disableSubmitBtn && (
                                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                        )}
                                                    </Button>
                                                    // </Col>
                                                )}
                                                {isKYCApproveAllowed() && (
                                                    // <Col style={{ textAlign: "center" }} className="d-flex flex-row">
                                                    <Button
                                                        label={"Approve"}
                                                        type="button"
                                                        icon={<Check size={16} />}
                                                        severity="success"
                                                        disabled={this.state.disableApproveBtn || this.complianceReviewRequired || this.residencePermitApprovalBlocked}
                                                        title={
                                                            this.complianceReviewRequired
                                                                ? "Complete compliance review before approving"
                                                                : this.residencePermitApprovalBlocked
                                                                    ? residencePermitApprovalBlockedMessage(this.state.residencePermitLoadState)
                                                                    : undefined
                                                        }
                                                        onClick={() => this.onApprove()}
                                                    >
                                                        {this.state.disableApproveBtn && (
                                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                        )}
                                                    </Button>
                                                    // </Col>
                                                )}
                                                {(isKYCApproveAllowed() || isKYCAssessAllowed()) && (
                                                    // <Col style={{ textAlign: "center" }}>
                                                    <Button
                                                        label={"Save draft"}
                                                        type="button"
                                                        icon={<Save size={16} />}
                                                        severity="secondary"
                                                        className="mx-5"
                                                        onClick={() => this.onSaveDraft()}
                                                    ></Button>
                                                    // </Col>
                                                )}
                                                {isKYCApproveAllowed() && (
                                                    // <Col style={{ textAlign: "center" }}>
                                                    <Button
                                                        label={"Reject"}
                                                        type="button"
                                                        icon={<X size={16} />}
                                                        severity="danger"
                                                        onClick={() => this.onReject()}
                                                    ></Button>
                                                    // </Col>
                                                )}
                                                {isKYCAssessAllowed() && (
                                                    // <Col style={{ textAlign: "center" }}>
                                                    <Button
                                                        label={"Escalate"}
                                                        type="button"
                                                        icon={<UserIcon size={16} />}
                                                        severity="danger"
                                                        onClick={() => this.onEscalate()}
                                                    ></Button>
                                                    // </Col>
                                                )}
                                            </Row>
                                        </AppCard.Body>
                                    </AppCard>
                    </PageLayout>
                    {this.state.showRejectDialog && (
                        <Dialog
                            header="Reject Kyc Submission"
                            visible={true}
                            style={{ width: "60vw" }}
                            modal
                            onHide={() => {
                                this.setState({ showRejectDialog: false });
                            }}
                        >
                            <div>
                                <Row>
                                    <Col>
                                        <InputTextarea
                                            rows={3}
                                            cols={90}
                                            onChange={(e) => {
                                                this.setState({ rejectionReason: e.target.value });
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button
                                            label={"Reject"}
                                            disabled={this.state.rejectionReason.length == 0}
                                            type="button"
                                            icon={<X size={16} />}
                                            severity="danger"
                                            onClick={() => this.onRejectWithReason()}
                                        ></Button>
                                    </Col>
                                </Row>
                            </div>
                        </Dialog>
                    )}
                    {this.state.showDiscardCountryOverrideDialog && (
                        <Dialog
                            header="Discard country parameter changes?"
                            visible={true}
                            style={{ width: "40vw" }}
                            modal
                            onHide={() => this.setState({ showDiscardCountryOverrideDialog: false })}
                        >
                            <div>
                                <Row>
                                    <Col>
                                        <p style={{ marginBottom: "20px" }}>You have unsaved changes to the Country of Registration, IP country or Geolocation. Discarding will revert them and clear the reason.</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ display: "flex", gap: "8px" }}>
                                        <Button
                                            label="Discard changes"
                                            type="button"
                                            icon={<X size={16} />}
                                            severity="danger"
                                            onClick={() => this.onConfirmDiscardCountryOverride()}
                                        ></Button>
                                        <Button
                                            label="Keep editing"
                                            type="button"
                                            severity="secondary"
                                            onClick={() => this.setState({ showDiscardCountryOverrideDialog: false })}
                                        ></Button>
                                    </Col>
                                </Row>
                            </div>
                        </Dialog>
                    )}
                </Fragment>
            </Dialog>
            </>
        );
    }
}
